import { Link, useRouterState } from "@tanstack/react-router";
import styles from "./Banner.module.css";
import { current, position, STEPS, visible } from "./steps.js";
import { useOnboarding } from "../../lib/queries.js";
import { useSession } from "../../lib/session.js";
import { Text } from "../../ui/index.js";

/**
 * Where you are in the walkthrough, on the screen the walkthrough sent you to.
 *
 * A step that says "add an account" and drops someone on `/accounts` has, at
 * that moment, no thread back: the checklist is on the dashboard and there is
 * nothing on this screen saying it is still going. This is that thread — the
 * step, how far through, and the way back.
 *
 * Not shown on the dashboard, which has the checklist itself, and not shown
 * once every step is done: at that point the way back is the payoff, not a
 * strip telling you to go and get it.
 */
export function OnboardingBanner() {
  const { householdId } = useSession();
  const path = useRouterState({ select: (state) => state.location.pathname });
  const query = useOnboarding(householdId);

  if (!query.data || !visible(query.data) || path === "/") return null;

  const step = current(query.data);
  if (!step) return null;

  const { done, total } = position(query.data);

  return (
    <div className={styles.banner}>
      <Text size="sm" tone="secondary">
        <span className={styles.count}>
          Step {String(done + 1)} of {String(total)}
        </span>
        {STEPS[step.id].label}
      </Text>
      <Link to="/" className={styles.back}>
        Back to the checklist
      </Link>
    </div>
  );
}
